import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/balance/useBalanceQueryKeys.ts
var t = e("balance", {
	forWorkspace: (e) => ["workspace", e],
	forListing: (e) => ["listing", e]
});
//#endregion
export { t as balanceQueryKeys };
